import {
  type IColumn,
  type ITableConfig,
  IconCopyButton,
  NameValueRecord,
  Typography,
  Box,
} from 'shared/ui'
import { EmptyCell } from 'shared/ui/Table'
import type { IClickToText } from 'entities/ClickToText'
import { QRDownloadButton } from './QRDownloadButton'
import styles from './styles.module.scss'

export const columns: IColumn<IClickToText>[] = [
  {
    field: 'name',
    name: 'Message',
    width: '100%',
    minWidth: '320px',
    maxWidth: '480px',
    isDisabledChangeVisible: true,
    renderRowCell: (row) => (
      <div className={styles.cellWrapper}>
        <div className={styles.messageWrap}>
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'name'}
            className={styles.name}
            ellipsis
            width={'100%'}
            tooltipProps={{
              label: row.name,
            }}
          >
            {row.name}
          </Typography>
          <Typography
            variant={'body-sm-regular'}
            color={'var(--content-primary-tertiary)'}
            ariaLabel={'message'}
            className={styles.message}
            ellipsis
            width={'100%'}
            tooltipProps={{
              label: row.message,
            }}
          >
            {row.message}
          </Typography>
        </div>
      </div>
    ),
  },
  {
    field: 'clicks',
    name: 'Clicks',
    minWidth: '80px',
    maxWidth: '80px',
    isDisabledChangeVisible: true,
    renderRowCell: (row) => (
      <Typography
        variant={'body-md-regular'}
        ariaLabel={'Clicks'}
        ellipsis
        color={'var(--content-primary-primary)'}
      >
        {row.statistics.total_count}
      </Typography>
    ),
  },
  {
    field: 'leads',
    name: 'Leads',
    minWidth: '80px',
    maxWidth: '80px',
    isDisabledChangeVisible: true,
    renderRowCell: (row) => (
      <Typography
        variant={'body-md-regular'}
        ariaLabel={'Leads'}
        ellipsis
        color={'var(--content-primary-primary)'}
      >
        {row.statistics.conversions_count}
      </Typography>
    ),
  },
  {
    field: 'link',
    name: 'Link',
    minWidth: '260px',
    maxWidth: '260px',
    disableLink: true,
    renderRowCell: (row, column, config?: ITableConfig) => (
      <Box display='flex' alignItems='center' width='100%' gap={1}>
        <div className={styles.linkWrapper}>
          <Typography
            variant={'body-md-regular'}
            ariaLabel={'Link'}
            ellipsis
            color={'var(--content-primary-primary)'}
            tooltipProps={{
              label: row.shortUrl,
            }}
          >
            {row.shortUrl}
          </Typography>
        </div>
        {config?.isHover && (
          <IconCopyButton
            value={row.shortUrl}
            tooltipProps={{ label: 'Copy', placement: 'top' }}
            toastTitle={'Link copied'}
            toastType={'success'}
          />
        )}
      </Box>
    ),
  },
  {
    field: 'qr',
    name: 'QR code',
    minWidth: '186px',
    disableLink: true,
    renderRowCell: (row) => <QRDownloadButton qrCode={row.qrCode} clickToText={row} />,
  },
  {
    field: 'text',
    name: 'Text in number',
    minWidth: '247px',
    isHideByDefault: true,
    renderRowCell: (row) =>
      row.number ? (
        <NameValueRecord
          icon='inboxes2'
          name={row.number.inbox_name}
          value={row.number.formatted_number}
        />
      ) : (
        <EmptyCell />
      ),
  },
]
